import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-md font-bold pt-2 pb-0 mb-0" }, "Profile", -1)
const _hoisted_2 = { class: "pl-2 text-sm" }
const _hoisted_3 = { class: "whitespace-pre-wrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 pb-0 mb-0" }, "Bio:", -1)
const _hoisted_5 = ["id"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 pb-0 mb-0" }, "Interests:", -1)
const _hoisted_8 = { class: "pl-4" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 pb-0 mb-0" }, "Topic Alerts:", -1)
const _hoisted_11 = { class: "pl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_follow_info = _resolveComponent("follow-info")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_follow_info, {
        user: _ctx.user,
        currentUser: _ctx.currentUser,
        class: "pb-4",
        onCloseSidebar: _ctx.closeSidebar
      }, null, 8, ["user", "currentUser", "onCloseSidebar"])
    ]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", {
          id: _ctx.elementId,
          class: "pl-4"
        }, null, 8, _hoisted_5)
      ]),
      (_ctx.user.interests)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.user.interests?.map(x => x['interest']).join('; ')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.currentUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.user.topics?.map(x => x['topic']).join('; ')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}